/* =========================================================================
   couplezine - script.js  (mobile-first build)
   - Sale-Countdown (Zeitfenster-Timer in der Ankündigungsleiste)
   - Warenkorb-Drawer: Shopify AJAX Cart, Rabattcodes, Bundle-Logik
   - Mobile Drawer-Menü + Body-Scroll-Lock
   - Sticky Bottom-CTA (mobil), Newsletter-Submit, PDP-Interaktionen
   ========================================================================= */

// Warenkorb-Preise IMMER mit zwei Nachkommastellen und Komma (z.B. "13,99 €").
// Vorher wurde auf ganze Euro gerundet — Cent-Beträge gingen in der Anzeige verloren.
const euroP = (n) => n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";

/* ---- tiny helpers ---- */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

/* ---- benefits ----
   WICHTIG: Der Inhalt kommt aus dem Shopify-Baukasten (sections/benefits.liquid)
   und wird hier NICHT mehr per JS überschrieben — nur die Einblendung. */
function revealBenefits() {
  const grid = $("#benefits-grid");
  if (!grid) return;

  // dezente Scroll-Einblendung der Zeilen
  const rows = grid.querySelectorAll(".benefit");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); obs.unobserve(e.target); } });
    }, { threshold: 0.25 });
    rows.forEach((r) => io.observe(r));
  } else {
    rows.forEach((r) => r.classList.add("is-in"));
  }
}

function startCountdown() {
  const saleTimers = Array.from(document.querySelectorAll("[data-sale-countdown]"));
  if (!saleTimers.length) return;

  const pad = (n) => String(n).padStart(2, "0");
  // Feste Tages-Zeitfenster: 0–12, 12–15, 15–20, 20–24 Uhr.
  // Der Countdown zählt jeweils bis zum Ende des aktuellen Fensters
  // und startet danach automatisch mit dem nächsten Fenster neu.
  const windowEndsHours = [12, 15, 20, 24];

  // DOM-Referenzen einmalig cachen (statt bei jedem Tick neu abzufragen)
  const timerRefs = saleTimers.map((timer) => ({
    timer,
    hours: timer.querySelector("[data-sale-hours]"),
    minutes: timer.querySelector("[data-sale-minutes]"),
    seconds: timer.querySelector("[data-sale-seconds]"),
    prev: { h: null, m: null, s: null },
  }));

  const tick = () => {
    const now = new Date();
    const curHour = now.getHours();
    let endHour = 24;
    for (let i = 0; i < windowEndsHours.length; i++) {
      if (curHour < windowEndsHours[i]) { endHour = windowEndsHours[i]; break; }
    }
    const end = new Date(now);
    end.setHours(endHour, 0, 0, 0); // Ende des aktuellen Fensters (24 = nächste Mitternacht)
    const diff = Math.max(0, Math.floor((end - now) / 1000));
    const h = pad(Math.floor(diff / 3600));
    const m = pad(Math.floor((diff % 3600) / 60));
    const s = pad(diff % 60);

    // Nur schreiben, wenn sich der jeweilige Wert geändert hat (weniger DOM-Writes)
    timerRefs.forEach((ref) => {
      if (ref.hours && ref.minutes && ref.seconds) {
        if (h !== ref.prev.h) { ref.hours.textContent = h; ref.prev.h = h; }
        if (m !== ref.prev.m) { ref.minutes.textContent = m; ref.prev.m = m; }
        if (s !== ref.prev.s) { ref.seconds.textContent = s; ref.prev.s = s; }
      } else {
        const str = `${h} : ${m} : ${s}`;
        if (str !== ref.prev.s) { ref.timer.textContent = str; ref.prev.s = str; }
      }
    });
  };
  tick();
  // Timer pausiert in inaktiven Tabs (spart CPU/Akku); beim Zurückkehren
  // rechnet tick() ohnehin frisch ab der aktuellen Uhrzeit.
  let timerId = setInterval(tick, 1000);
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) { clearInterval(timerId); timerId = null; }
    else if (!timerId) { tick(); timerId = setInterval(tick, 1000); }
  });
}

/* ---- cart state + toast ---- */
let cart = [];   // { id, key, variantId, name, qty, price, comparePrice, linePrice, image }
let toastTimer = null;
let _lastAdded = null;

function showToast(msg) {
  const t = $("#toast");
  if (!t) return;
  t.textContent = msg;
  t.classList.add("is-visible");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove("is-visible"), 1900);
}

/* ---- Line-Item-Properties einsammeln (z.B. Uploadly-Datei-Upload) ----
   Upload-Apps schreiben die hochgeladene Datei als verstecktes Feld
   name="properties[...]" ins Produkt-Formular. Diese Werte MÜSSEN beim
   AJAX-Hinzufügen mitgeschickt werden, sonst kommt die Datei nie in der
   Bestellung an. Gesucht wird zuerst im Produkt-Formular, dann auf der
   ganzen Seite (falls die App ihren Block außerhalb platziert). */
function collectLineItemProperties() {
  let fields = document.querySelectorAll('#product-form [name^="properties["]');
  if (!fields.length) fields = document.querySelectorAll('[name^="properties["]');
  if (!fields.length) return null;
  const props = {};
  let found = false;
  fields.forEach((el) => {
    const m = /^properties\[([\s\S]+)\]$/.exec(el.name);
    if (!m) return;
    if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
    // Datei-Inputs selbst können per JSON nicht übertragen werden — Upload-Apps
    // hinterlegen die fertige Datei-URL ohnehin in einem separaten Hidden-Feld.
    if (el.type === "file") return;
    const v = (el.value != null ? String(el.value) : "").trim();
    if (v === "") return;
    props[m[1]] = v;
    found = true;
  });
  return found ? props : null;
}

function selectedMfyPosterUpsells() {
  return Array.from(document.querySelectorAll("[data-mfy-poster-upsells] [data-mfy-upsell-variant]:checked"))
    .map((input) => ({
      variantId: input.dataset.mfyUpsellVariant || "",
      name: input.dataset.mfyUpsellName || "Extra"
    }))
    .filter((item) => item.variantId);
}

function addSelectedMfyPosterUpsells() {
  selectedMfyPosterUpsells().forEach((extra) => {
    addItem(extra.variantId, extra.name, 1, null, false, { _MFY_POSTER_EXTRA: "1" });
  });
}

/* ---- Shopify AJAX Cart: schlanker fetch-Wrapper ---- */
async function shopifyCartRequest(url, options) {
  const res = await fetch(url, Object.assign({
    headers: { "Content-Type": "application/json", "Accept": "application/json" }
  }, options || {}));
  if (!res.ok) {
    let detail = "";
    try { detail = (await res.json()).description || ""; } catch (e) {}
    throw new Error(detail || ("Cart request failed: " + res.status));
  }
  return res.json();
}

function getCart() {
  return shopifyCartRequest("/cart.js", { method: "GET" });
}

/* ---- Rabattcode anwenden ---- */
let _appliedDiscount = null;
let _pendingDiscount = null;

function discountStatusFor(cartObj, code) {
  const wanted = (code || "").trim().toLowerCase();
  const list = cartObj && cartObj.discount_codes ? cartObj.discount_codes : [];
  const entry = list.find((d) => (d.code || "").toLowerCase() === wanted);
  if (!entry) return "absent";
  return entry.applicable ? "applicable" : "not_applicable";
}

/* Flag: solange true, darf applyServerCart keinen Rabatt aus einem evtl.
   veralteten Server-Cart re-aktivieren. Verhindert das "Zurückkommen" des
   Rabatts direkt nach dem Entfernen. */
let _discountClearing = false;

function cartHasAnyDiscount(cartObj) {
  const list = cartObj && cartObj.discount_codes ? cartObj.discount_codes : [];
  const active = list.some((d) => d && d.applicable);
  return active || (cartObj && cartObj.total_discount > 0);
}

async function clearDiscountCode(quick) {
  _discountClearing = true;
  _appliedDiscount = null;
  _pendingDiscount = null;
  _shopifyCodeDiscount = 0;

  // Rabatt bei Shopify entfernen: sowohl die Discount-Session als auch den
  // Cart-Discount leeren.
  async function sendClear() {
    const a = fetch("/discount/clear", { method: "GET", redirect: "manual" }).catch(() => {});
    const b = shopifyCartRequest("/cart/update.js", {
      method: "POST",
      body: JSON.stringify({ discount: "" })
    }).catch(() => {});
    await Promise.all([a, b]);
  }

  try {
    await sendClear();

    // SCHNELL-MODUS: Beim WECHSEL auf einen neuen Code reicht einmaliges
    // Leeren — der direkt danach gesetzte neue Code überschreibt die
    // Discount-Session ohnehin. Die (langsame) Verifikations-Schleife ist
    // nur beim endgültigen ENTFERNEN eines Codes nötig.
    if (quick) return null;

    // Verifizieren, dass der Rabatt wirklich weg ist. Shopify verarbeitet das
    // Entfernen gelegentlich mit kurzer Verzögerung – daher bis zu 4 Versuche
    // mit kleinen Pausen, statt sofort weiterzumachen.
    for (let attempt = 0; attempt < 4; attempt++) {
      let c = null;
      try { c = await getCart(); } catch (e) { c = null; }
      if (c && !cartHasAnyDiscount(c)) {
        _shopifyCodeDiscount = 0;
        return c;
      }
      // Noch nicht sauber -> kurz warten und erneut clearen.
      await new Promise((r) => setTimeout(r, 260));
      await sendClear();
    }
  } finally {
    _discountClearing = false;
  }
  return null;
}

async function applyDiscountCode(code, skipClear) {
  code = (code || "").trim();
  if (!code) return { ok: false, reason: "empty" };

  if (!skipClear) {
    // Nur aufräumen, wenn wirklich ein anderer Code aktiv oder vorgemerkt ist —
    // und dann schnell (ohne Verifikations-Schleife). Bei der ersten Eingabe
    // ohne aktiven Rabatt entfällt das Aufräumen komplett; der Code wird
    // sofort geprüft.
    const hasActive = !!(_appliedDiscount || _pendingDiscount || _shopifyCodeDiscount > 0);
    if (hasActive) await clearDiscountCode(true);
  }

  try {
    await fetch("/discount/" + encodeURIComponent(code), { method: "GET", redirect: "manual" });
  } catch (e) {}
  
  const c = await getCart();
  const status = discountStatusFor(c, code);
  
  if (status === "applicable") {
    const discountValue = c.total_discount || 0;
    _appliedDiscount = { code: code, value: discountValue };
    _pendingDiscount = code;
    _shopifyCodeDiscount = discountValue;
    mapShopifyCartItems(c);
    computeCartTotals();
    return { ok: true, value: discountValue, cart: c };
  }

  // WICHTIG: Shopify zeigt Rabatte (v.a. automatische oder solche mit
  // Bedingungen) oft NICHT sofort in /cart.js an – sie greifen erst im
  // Checkout. Deshalb den Code NICHT verwerfen, sondern als "pending"
  // merken. Er wird beim Checkout an die URL gehängt (?discount=CODE)
  // und greift dort. So funktionieren Rabattcodes zuverlässig, statt
  // fälschlich als "ungültig" wieder entfernt zu werden.
  if (status === "absent") {
    _pendingDiscount = code;
    _appliedDiscount = { code: code, value: c.total_discount || 0 };
    _shopifyCodeDiscount = c.total_discount || 0;
    mapShopifyCartItems(c);
    computeCartTotals();
    return { ok: true, value: c.total_discount || 0, pending: true, cart: c };
  }

  // Nur wenn Shopify den Code ausdrücklich als NICHT anwendbar meldet
  // (status === "not_applicable"), entfernen wir ihn wieder.
  await clearDiscountCode(true);
  const fresh = await getCart();
  _shopifyCodeDiscount = 0;
  mapShopifyCartItems(fresh);
  computeCartTotals();
  return { ok: false, reason: "not_applicable", cart: fresh };
}

/* ---- PERFORMANCE & ROBUSTHEIT ---- */
let _cartOpChain = Promise.resolve();
function queueCartOp(fn) {
  const run = _cartOpChain.then(fn, fn);
  _cartOpChain = run.catch(() => {});
  return run;
}

let _pendingOps = 0;
let _lastServerCart = null;

function enqueueWrite(doWrite) {
  _pendingOps++;
  return queueCartOp(async () => {
    try {
      const c = await doWrite();
      if (c) _lastServerCart = c;
    } catch (err) {
      console.error("couplezine cart write error:", err);
      showToast("warenkorb konnte nicht aktualisiert werden");
    } finally {
      _pendingOps--;
      if (_pendingOps === 0) {
        const hasPendingDesire = Object.keys(_desiredQty).length > 0;
        if (!hasPendingDesire) {
          try {
            await applyServerCart(_lastServerCart || (await getCart()));
          } catch (e) { console.error("couplezine finalize error:", e); }
          _lastServerCart = null;
        }
      }
    }
  });
}

function cartAdd(variantId, quantity, sellingPlan, properties) {
  var item = { id: variantId, quantity: quantity || 1 };
  if (sellingPlan) item.selling_plan = sellingPlan;
  if (properties) item.properties = properties;
  return shopifyCartRequest("/cart/add.js", {
    method: "POST",
    body: JSON.stringify({ items: [item] })
  });
}

// Leert den kompletten Warenkorb bei Shopify. Wird genutzt, wenn ein neues
// Haupt-Produkt/Bundle den Warenkorb ERSETZEN soll (nicht anhängen), z.B. beim
// Wechsel von kleinem zu großem Bundle. Der lokale Zustand wird ebenfalls
// geleert, damit optimistische Anzeige und Server konsistent bleiben.
async function cartClear() {
  try {
    await shopifyCartRequest("/cart/clear.js", { method: "POST" });
  } catch (e) {
    console.error("couplezine cart clear error:", e);
  }
  cart = [];
  _desiredQty = Object.create(null);
  _qtyWriteScheduled = Object.create(null);
  _hasServerTotals = false;
}

function cartChange(key, quantity) {
  return shopifyCartRequest("/cart/change.js", {
    method: "POST",
    body: JSON.stringify({ id: key, quantity: Number(quantity) })
  });
}

function cartUpdate(updates) {
  return shopifyCartRequest("/cart/update.js", {
    method: "POST",
    body: JSON.stringify({ updates: updates || {} })
  });
}

function cartLineProperties(line) {
  return line && line.properties && typeof line.properties === "object" ? line.properties : {};
}

function bundleIdFromProps(props) {
  return props && props._mf_bundle_id ? String(props._mf_bundle_id) : "";
}

function bundleRoleFromProps(props) {
  return props && props._mf_bundle_role ? String(props._mf_bundle_role) : "";
}

function bundleRequiredPaidFromProps(props) {
  const raw = props && props._mf_bundle_required_paid ? String(props._mf_bundle_required_paid) : "";
  return raw.split(",").map((id) => id.trim()).filter(Boolean);
}

function bundleIntegrityUpdatesFromItems(items) {
  const groups = Object.create(null);
  (items || []).forEach((line) => {
    const props = cartLineProperties(line);
    const bundleId = bundleIdFromProps(props);
    if (!bundleId) return;
    if (!groups[bundleId]) groups[bundleId] = [];
    groups[bundleId].push(line);
  });

  const updates = {};
  Object.keys(groups).forEach((bundleId) => {
    const lines = groups[bundleId];
    let requiredPaid = [];
    lines.forEach((line) => {
      if (!requiredPaid.length) requiredPaid = bundleRequiredPaidFromProps(cartLineProperties(line));
    });

    const presentPaid = new Set();
    let hasFree = false;
    lines.forEach((line) => {
      const props = cartLineProperties(line);
      const role = bundleRoleFromProps(props);
      const qty = Number(line.quantity || 0);
      if (role === "free" && qty > 0) hasFree = true;
      if (role === "paid" && qty > 0) presentPaid.add(String(line.variant_id));
    });

    const requiredMissing = requiredPaid.length > 0 && !requiredPaid.every((id) => presentPaid.has(String(id)));
    if (hasFree && (presentPaid.size === 0 || requiredMissing)) {
      lines.forEach((line) => {
        const props = cartLineProperties(line);
        if (bundleRoleFromProps(props) === "free") updates[line.key] = 0;
      });
    }
  });

  return updates;
}

async function enforceBundleIntegrity(shopifyCart) {
  const current = shopifyCart || (await getCart());
  const updates = bundleIntegrityUpdatesFromItems(current && current.items);
  if (!Object.keys(updates).length) return current;
  return cartUpdate(updates);
}

function mapShopifyCartItems(shopifyCart) {
  // Echte Shopify-Summen merken (maßgeblich für die Gesamtsumme, damit sich
  // mehrere Rabatte nicht doppelt abziehen).
  if (shopifyCart && typeof shopifyCart.total_price === "number") {
    _serverTotalPrice = shopifyCart.total_price;
    _serverItemsSubtotal = (typeof shopifyCart.items_subtotal_price === "number") ? shopifyCart.items_subtotal_price : shopifyCart.total_price;
    _serverTotalDiscount = shopifyCart.total_discount || 0;
    _hasServerTotals = true;
  }
  const prevByKey = Object.create(null);
  const prevOrder = [];
  for (const it of cart) { prevByKey[it.key] = it; prevOrder.push(it.key); }

  const mapped = Object.create(null);
  for (const i of shopifyCart.items) {
    const hasPending = i.key in _desiredQty;
    // Zwingend den vom Nutzer gewünschten _desiredQty Wert nutzen!
    const qty = hasPending ? _desiredQty[i.key] : i.quantity;
    
    // Wenn die Menge 0 ist (wurde gerade gelöscht), ignorieren wir das Item
    if (qty <= 0) continue; 

    const unit = i.final_price;
    const unitCompare = i.original_price;
    let linePrice = hasPending ? unit * qty : i.final_line_price;
    let compareLinePrice = hasPending ? unitCompare * qty : i.original_line_price;

    const props = cartLineProperties(i);
    const roleForPrice = bundleRoleFromProps(props);
    // Gratis-Bundle-Positionen (z.B. die Anleitung) garantiert als 0 € anzeigen,
    // mit dem Originalpreis als Streichpreis. Der tatsächliche 0€-Betrag im
    // Checkout kommt vom automatischen Shopify-Rabatt.
    if (roleForPrice === "free") {
      const origUnit = (i.original_price != null ? i.original_price : (i.price || 0));
      compareLinePrice = origUnit * qty;
      linePrice = 0;
    }
    mapped[i.key] = {
      id: i.variant_id, key: i.key, variantId: i.variant_id,
      name: i.product_title || i.title, qty: qty,
      handle: i.handle || "",
      price: unit, comparePrice: unitCompare,
      linePrice: linePrice, compareLinePrice: compareLinePrice,
      image: i.image,
      properties: props,
      bundleId: bundleIdFromProps(props),
      bundleRole: bundleRoleFromProps(props),
      bundleRequiredPaid: bundleRequiredPaidFromProps(props)
    };
  }

  const result = [];
  const used = new Set();
  for (const key of prevOrder) {
    if (mapped[key]) { result.push(mapped[key]); used.add(key); }
  }
  for (const i of shopifyCart.items) {
    // mapped[i.key] fehlt, wenn die Zeile lokal bereits auf 0 gesetzt wurde
    // (Löschen steht noch aus). Ohne diese Prüfung landete `undefined` im
    // Warenkorb-Array und ließ cartQty()/renderCart() mit einem Fehler abbrechen.
    if (!used.has(i.key) && mapped[i.key]) { result.push(mapped[i.key]); used.add(i.key); }
  }
  cart = result;
}

function cartQty() { return cart.reduce((n, i) => n + i.qty, 0); }

/* ---- Warenkorb-Summen: echte Shopify-Preise, keine automatischen Mengenrabatte ---- */
let _shopifyCartTotal = 0;          // in Cent, echte Shopify-Finalpreise (nach Rabattcode)
let _shopifyCartOriginalTotal = 0;  // in Cent, Original-/Compare-Summe falls vorhanden
let _shopifyCodeDiscount = 0;       // in Cent, per Rabattcode gewährter Nachlass (Shopify total_discount)
let _serverTotalPrice = 0;          // Shopify total_price (nach ALLEN Rabatten)
let _serverItemsSubtotal = 0;       // Shopify items_subtotal_price (vor Rabatten)
let _serverTotalDiscount = 0;       // Shopify total_discount
let _hasServerTotals = false;       // liegen echte Server-Summen vor?

function computeCartTotals() {
  let total = 0;
  let originalTotal = 0;
  cart.forEach((i) => {
    const line = Number.isFinite(i.linePrice) ? i.linePrice : (i.price || 0) * (i.qty || 0);
    const compare = Number.isFinite(i.compareLinePrice) ? i.compareLinePrice : line;
    total += line;
    originalTotal += Math.max(compare, line);
  });

  // WICHTIG: Wenn echte Shopify-Summen vorliegen, sind DIESE maßgeblich für
  // die Gesamtsumme. Shopify hat dort bereits ALLE Rabatte (automatischer
  // Bundle-Rabatt + Rabattcode) korrekt verrechnet. Selbst zu rechnen und
  // zusätzlich total_discount abzuziehen würde doppelt zählen (Preis fiele
  // fälschlich Richtung 0).
  if (_hasServerTotals) {
    _shopifyCartTotal = Math.max(0, _serverTotalPrice);
    // Ursprungssumme = Summe der regulären Preise (für "Du sparst"),
    // mindestens aber die tatsächliche Endsumme.
    _shopifyCartOriginalTotal = Math.max(_shopifyCartTotal, originalTotal, _serverItemsSubtotal);
  } else {
    // Lokaler Zwischenstand (optimistisch), bevor der Server frische Summen
    // liefert. Hier NICHT zusätzlich den Rabattcode abziehen – das würde
    // doppelt zählen, sobald auch ein automatischer Rabatt aktiv ist. Die
    // exakte Endsumme setzt gleich der Server-Cart.
    _shopifyCartTotal = Math.max(0, total);
    _shopifyCartOriginalTotal = Math.max(_shopifyCartTotal, originalTotal);
  }
}

function cartTotal() { return _shopifyCartTotal / 100; }
function cartSavings() { return Math.max(0, (_shopifyCartOriginalTotal - _shopifyCartTotal) / 100); }

function renderCart() {
  const qty = cartQty();
  const total = cartTotal();
  
  const badge = $("#cart-count"); if (badge) { badge.textContent = qty; badge.classList.toggle("is-empty", qty === 0); }
  const qEl = $("#cart-qty"); if (qEl) qEl.textContent = qty;
  
  const notice = $("#cart-notice"); if (notice) notice.hidden = qty === 0;

  const savings = cartSavings();
  const saveEl = $("#cart-save"); if (saveEl) saveEl.textContent = "-" + euroP(savings);
  const saveRow = $("#cart-save-row"); if (saveRow) { saveRow.classList.toggle("is-saving", savings > 0); saveRow.hidden = savings <= 0; }
  const totEl  = $("#cart-total"); if (totEl)  { totEl.textContent = euroP(total); }
  
  const scrollEl = document.querySelector(".cart__scroll");
  const savedScroll = scrollEl ? scrollEl.scrollTop : 0;
  const wrap = $("#cart-items");
  
  if (wrap) {
    if (cart.length === 0) {
      wrap.innerHTML = `<div class="cart__empty">dein warenkorb ist noch leer.</div>`;
    } else {
      const empty = wrap.querySelector(".cart__empty");
      if (empty) empty.remove();
      const seen = new Set();
      let prevNode = null;
      cart.forEach((i) => {
        seen.add(i.key);
        let ci = wrap.querySelector(`.ci [data-inc="${i.key}"]`);
        ci = ci ? ci.closest(".ci") : null;
        if (!ci) {
          ci = document.createElement("div");
          ci.className = "ci" + (i.key === _lastAdded ? " ci--in" : "");
          const isDruckenLine = ((i.handle || "").toLowerCase().indexOf("drucken") !== -1) ||
                                ((i.name || "").toLowerCase().indexOf("drucken lassen") !== -1);
          // Anleitung / Gratis-Anleitung: keine "Personalisierung nach der
          // Bestellung"-Zeile. Erkannt über die Gratis-Rolle, die Free-Guide-
          // Property oder "anleitung" im Produktnamen/Handle.
          const props = i.properties || {};
          const isGuideLine = (i.bundleRole === "free") ||
                              (props._mf_free_guide === "1" || props._mf_free_guide === 1) ||
                              ((i.handle || "").toLowerCase().indexOf("anleitung") !== -1) ||
                              ((i.name || "").toLowerCase().indexOf("anleitung") !== -1);
          const persoLine = (isDruckenLine || isGuideLine) ? "" :
            `<div class="ci__perso"><span class="ci__perso-dot" aria-hidden="true"></span>Personalisierung nach der Bestellung</div>`;
          // Sichtbare Line-Item-Properties (ohne _interne): z.B. die per Uploadly
          // hochgeladene Datei. Lange URLs werden als "hochgeladen ✓" angezeigt.
          const propLines = Object.keys(props)
            .filter((k) => k && k.charAt(0) !== "_" && props[k])
            .map((k) => {
              const v = String(props[k]);
              const shown = /^https?:\/\//i.test(v)
                ? '<span class="ci__prop-ok">hochgeladen ✓</span>'
                : esc(v.length > 48 ? v.slice(0, 48) + "…" : v);
              return `<div class="ci__prop">${esc(k)}: ${shown}</div>`;
            }).join("");
          ci.innerHTML = `
            <div class="ci__thumb"><img src="${i.image || ""}" alt=""></div>
            <div class="ci__body">
              <div class="ci__name">${esc(i.name)}</div>
              ${propLines}
              ${persoLine}
              <div class="ci__qty">
                <button data-dec="${i.key}" aria-label="weniger">\u2212</button>
                <span>${i.qty}</span>
                <button data-inc="${i.key}" aria-label="mehr">+</button>
              </div>
            </div>
            <div class="ci__side">
              <button class="ci__remove" data-remove="${i.key}" aria-label="entfernen">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/></svg>
              </button>
              <div class="ci__price"></div>
            </div>`;
        } else {
          const qs = ci.querySelector(".ci__qty span");
          if (qs && qs.textContent != i.qty) qs.textContent = i.qty;
        }
        
        const priceBox = ci.querySelector(".ci__price");
        if (priceBox) {
          const strike = i.compareLinePrice > i.linePrice ? `<span class="strike">${euroP(i.compareLinePrice / 100)}</span>` : "";
          const html = strike + `<strong>${euroP(i.linePrice / 100)}</strong>`;
          if (priceBox.innerHTML !== html) priceBox.innerHTML = html;
        }
        
        const anchor = prevNode ? prevNode.nextSibling : wrap.firstChild;
        if (ci !== anchor) wrap.insertBefore(ci, anchor);
        prevNode = ci;
      });
      
      wrap.querySelectorAll(".ci").forEach((node) => {
        const incBtn = node.querySelector("[data-inc]");
        const key = incBtn ? incBtn.dataset.inc : null;
        if (key && !seen.has(key)) node.remove();
      });
    }
  }
  
  if (scrollEl) scrollEl.scrollTop = savedScroll;
  _lastAdded = null;
  syncPromoUI();
}

function syncPromoUI() {
  const form = document.getElementById("cart-promo");
  if (!form) return;
  const input = document.getElementById("promo-input");
  const btn = document.getElementById("promo-btn");
  const msg = document.getElementById("promo-msg");
  
  if (input && document.activeElement === input) return;
  
  const setMsg = (text, ok) => {
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle("is-ok", !!ok);
    msg.classList.toggle("is-err", !ok);
    msg.hidden = false;
  };
  
  if (_appliedDiscount && _appliedDiscount.code) {
    const wasActive = form.classList.contains("is-active");
    form.classList.remove("is-invalid");
    form.classList.add("is-active");
    if (input && !input.value.trim()) input.value = _appliedDiscount.code.toUpperCase();
    if (btn) btn.textContent = "aktiv";
    const msgVisible = msg && !msg.hidden;
    if (!wasActive || msgVisible) {
      setMsg("code  " + _appliedDiscount.code.toUpperCase() + "  angewendet.", true);
    }
  } else {
    form.classList.remove("is-active");
    if (btn) btn.textContent = "einlösen";
    // Nur veraltete "angewendet"-Bestätigungen ausblenden — Meldungen wie
    // "rabattcode entfernt." sollen sichtbar bleiben, auch wenn kurz danach
    // das stille Server-Update erneut rendert.
    if (msg && msg.classList.contains("is-ok") && msg.textContent.indexOf("angewendet") !== -1) msg.hidden = true;
  }
}

async function applyServerCart(shopifyCart) {
  mapShopifyCartItems(shopifyCart);

  // Während ein Rabatt aktiv entfernt wird, keinen Rabatt aus einem evtl.
  // noch veralteten Server-Cart übernehmen (sonst "kommt er zurück").
  if (_discountClearing) {
    _appliedDiscount = null;
    _pendingDiscount = null;
    _shopifyCodeDiscount = 0;
    computeCartTotals();
    renderCart();
    return shopifyCart;
  }

  if (_pendingDiscount && cartQty() > 0) {
    const already = (shopifyCart.discount_codes || []).some(
      (d) => d.applicable && d.code.toLowerCase() === _pendingDiscount.toLowerCase()
    );
    if (!already) {
      try {
        await fetch("/discount/" + encodeURIComponent(_pendingDiscount), { method: "GET", redirect: "manual" });
        shopifyCart = await getCart();
        mapShopifyCartItems(shopifyCart);
      } catch (e) {}
    }
  }

  const applicableCodes = (shopifyCart.discount_codes || [])
    .filter((d) => d.applicable);

  // Rabattcode-Nachlass aus dem Server-Cart übernehmen, damit "Du sparst"
  // und "Gesamtsumme" mit dem späteren Checkout übereinstimmen.
  _shopifyCodeDiscount = applicableCodes.length > 0 ? (shopifyCart.total_discount || 0) : 0;

  // Summen berechnen (inkl. Rabattcode-Nachlass)
  computeCartTotals();

  if (applicableCodes.length > 0) {
    _appliedDiscount = { code: applicableCodes[0].code, value: shopifyCart.total_discount || 0 };
    _pendingDiscount = null;
  } else {
    _appliedDiscount = null;
    if (_pendingDiscount && cartQty() > 0) _pendingDiscount = null;
  }

  renderCart();
  return shopifyCart;
}

async function syncCartFromShopify() {
  try {
    const shopifyCart = await enforceBundleIntegrity(await getCart());
    return await applyServerCart(shopifyCart);
  } catch (err) {
    console.error("couplezine cart sync error:", err);
    showToast("warenkorb konnte nicht geladen werden");
  }
}

// Rendert den Warenkorb direkt aus der Antwort von /cart/add.js. Nach einem
// "Ersetzen"-Kauf sind die zurückgegebenen Items der komplette Warenkorb —
// so erscheint der Inhalt einen vollen Server-Roundtrip früher. Die exakten
// Summen/Rabatte zieht der anschließende getCart still nach.
function renderCartFromAddedItems(items) {
  if (!items || !items.length) return;
  mapShopifyCartItems({ items: items });
  _hasServerTotals = false; // Summen lokal rechnen, bis der Server-Cart eintrifft
  computeCartTotals();
  renderCart();
}

// Optimistische Warenkorb-Zeile fürs Hauptprodukt: nutzt die vom Liquid am
// Kauf-Button hinterlegten Daten (Preis/Streichpreis/Bild in Cents). Liefert
// null, wenn keine verlässlichen Daten da sind — dann lieber nichts Falsches
// anzeigen und auf die Server-Antwort warten.
function optimisticLineFromBuyButton(id, name, n) {
  const btn = document.getElementById("buy-add");
  if (!btn || String(btn.dataset.variant) !== String(id)) return null;
  const price = parseInt(btn.dataset.price, 10);
  if (isNaN(price) || price < 0) return null;
  let compare = parseInt(btn.dataset.compare, 10);
  if (isNaN(compare) || compare < price) compare = price;
  return {
    id: id, key: "optimistic-main", variantId: id,
    name: name || (btn.dataset.name || ""), qty: n,
    price: price, comparePrice: compare,
    linePrice: price * n, compareLinePrice: compare * n,
    image: btn.dataset.image || "",
    properties: {}, bundleId: "", bundleRole: "", bundleRequiredPaid: 0
  };
}

// Optimistische Zeile für die Gratis-Anleitung (Daten aus dem body-Tag).
function optimisticGuideLine() {
  const body = document.body;
  const vid = body.getAttribute("data-free-guide-variant");
  if (!vid) return null;
  const price = parseInt(body.getAttribute("data-free-guide-price") || "0", 10) || 0;
  return {
    id: vid, key: "optimistic-guide", variantId: vid,
    name: body.getAttribute("data-free-guide-title") || "Anleitung", qty: 1,
    price: 0, comparePrice: price,
    linePrice: 0, compareLinePrice: price,
    image: body.getAttribute("data-free-guide-image") || "",
    properties: { _mf_free_guide: "1", _mf_bundle_role: "free" },
    bundleId: "", bundleRole: "free", bundleRequiredPaid: 0
  };
}

// Zeigt die neuen Zeilen sofort an (ersetzt die Anzeige, wie es der Kauf
// gleich auch serverseitig tut).
function optimisticShowNewCart(lines) {
  lines = (lines || []).filter(Boolean);
  if (!lines.length) return;
  cart = lines;
  _hasServerTotals = false;
  computeCartTotals();
  renderCart();
}

function popEl(el) {
  if (!el) return;
  el.classList.remove("pop");
  void el.offsetWidth;
  el.classList.add("pop");
}

// Fügt ein Magazin hinzu – und beim normalen Einzelkauf automatisch die
// Gratis-Anleitung dazu (als Gratis-Position). Nicht bei "Drucken lassen".
function addItemWithGuide(id, name, n, sellingPlan, isDruckservice) {
  n = n || 1;
  if (!id) return;

  // Upload-/App-Eigenschaften (z.B. Uploadly-Datei) am Hauptprodukt mitgeben
  const lineProps = collectLineItemProperties();

  const guideVariant = document.body.getAttribute("data-free-guide-variant");
  // Anleitung nur mitgeben, wenn: konfiguriert, kein Druckservice, und das
  // Magazin nicht die Anleitung selbst ist.
  const addGuide = guideVariant && !isDruckservice && String(guideVariant) !== String(id);

  if (!addGuide) {
    // replace = true: ein neues Magazin ERSETZT den bisherigen Warenkorb.
    return addItem(id, name, n, sellingPlan, true, lineProps);
  }

  openCart();

  // SOFORT-FEEDBACK (0 ms): Magazin + Gratis-Anleitung direkt anzeigen, noch
  // bevor der erste Server-Roundtrip startet. Die Daten kommen vom Kauf-Button
  // bzw. body-Tag; die Server-Antwort ersetzt die Zeilen gleich 1:1.
  const optiMain = optimisticLineFromBuyButton(id, name, n);
  if (optiMain) {
    _lastAdded = optiMain.key;
    optimisticShowNewCart([optiMain, optimisticGuideLine()]);
  }

  return enqueueWrite(async () => {
    // Neues Haupt-Produkt ersetzt den Warenkorb: vorher alles leeren, damit
    // z.B. ein zuvor gewähltes anderes Magazin/Bundle nicht liegen bleibt.
    await cartClear();
    // Magazin + Anleitung in einem Rutsch hinzufügen. Die Anleitung wird als
    // Gratis-Position markiert (role=free), damit sie im Warenkorb mit 0 €
    // erscheint. Der tatsächliche 0€-Betrag kommt vom Shopify-Rabatt.
    const items = [
      { id: Number(id), quantity: n },
      { id: Number(guideVariant), quantity: 1, properties: { _mf_free_guide: "1", _mf_bundle_role: "free" } }
    ];
    if (sellingPlan) items[0].selling_plan = sellingPlan;
    if (lineProps) items[0].properties = lineProps;
    try {
      const addResp = await shopifyCartRequest("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({ items: items })
      });
      // Echte Daten sofort rendern (ein Roundtrip früher als vorher).
      if (addResp && addResp.items) renderCartFromAddedItems(addResp.items);
    } catch (e) {
      // Falls das Bündeln fehlschlägt, wenigstens das Magazin hinzufügen.
      try {
        const solo = await cartAdd(id, n, sellingPlan, lineProps);
        if (solo && solo.items) renderCartFromAddedItems(solo.items);
      } catch (e2) {}
    }
    try {
      const fresh = await getCart();
      mapShopifyCartItems(fresh);
      computeCartTotals();
      renderCart();
    } catch (e) {}
    // Keine "hinzugefügt"-Meldung – der Warenkorb öffnet sich automatisch.
    return null;
  });
}

function addItem(id, name, n, sellingPlan, replace, properties) {
  n = n || 1;
  if (!id) return;
  openCart();

  // SOFORT-FEEDBACK beim Ersetzen-Kauf (z.B. "Drucken lassen"): das Produkt
  // direkt anzeigen, Server-Antwort ersetzt die Zeile gleich 1:1.
  if (replace) {
    const opti = optimisticLineFromBuyButton(id, name, n);
    if (opti) {
      if (properties) opti.properties = properties;
      _lastAdded = opti.key;
      optimisticShowNewCart([opti]);
    }
  }

  return enqueueWrite(async () => {
    // replace = true: bestehenden Warenkorb vor dem Hinzufügen leeren (das neue
    // Produkt ersetzt den Inhalt). Der Upsell-Duft ruft addItem OHNE replace
    // auf und wird deshalb wie gewohnt zusätzlich hinzugefügt.
    if (replace) {
      await cartClear();
      try {
        const addResp = await cartAdd(id, n, sellingPlan, properties);
        // Echte Daten sofort rendern (ein Roundtrip früher als vorher).
        if (addResp && addResp.items) renderCartFromAddedItems(addResp.items);
        const fresh = await getCart();
        mapShopifyCartItems(fresh);
        computeCartTotals();
        renderCart();
      } catch (e) {
        console.error("couplezine replace add error:", e);
      }
      // Keine "hinzugefügt"-Meldung – der Warenkorb öffnet sich automatisch.
      return null;
    }
    const addResp = await cartAdd(id, n, sellingPlan, properties);
    const addedLine = addResp && addResp.items ? addResp.items[0] : addResp;
    if (_pendingOps === 1 && addedLine && addedLine.key) {
      _lastAdded = addedLine.key;
      const existing = cart.find((i) => i.key === addedLine.key);
      if (existing) {
        applyOptimisticQty(addedLine.key, existing.qty + (addedLine.quantity || n));
      } else {
        const lp = addedLine.final_line_price != null ? addedLine.final_line_price : (addedLine.line_price || 0);
        const olp = addedLine.original_line_price != null ? addedLine.original_line_price : lp;
        const addedProps = cartLineProperties(addedLine);
        cart.push({
          id: addedLine.variant_id,
          key: addedLine.key,
          variantId: addedLine.variant_id,
          name: addedLine.product_title || addedLine.title || (name || ""),
          qty: addedLine.quantity || n,
          price: addedLine.final_price != null ? addedLine.final_price : addedLine.price,
          comparePrice: addedLine.original_price != null ? addedLine.original_price : addedLine.price,
          linePrice: lp,
          compareLinePrice: olp,
          image: addedLine.image || "",
          properties: addedProps,
          bundleId: bundleIdFromProps(addedProps),
          bundleRole: bundleRoleFromProps(addedProps),
          bundleRequiredPaid: bundleRequiredPaidFromProps(addedProps)
        });
        computeCartTotals();
      }
      renderCart();
    }
    // Keine "hinzugefügt"-Meldung – der Warenkorb öffnet sich automatisch.
    return null;
  });
}

function applyOptimisticQty(key, newQty) {
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  const target = Math.max(0, newQty);
  if (target <= 0) {
    cart = cart.filter((i) => i.key !== key);
  } else {
    line.qty = target;
    if (typeof line.linePrice === "number") line.linePrice = line.price * target;
    if (typeof line.compareLinePrice === "number") {
      line.compareLinePrice = (line.comparePrice || line.price) * target;
    }
  }
  // Optimistische Änderung: Server-Summen sind jetzt veraltet -> lokal rechnen,
  // bis der Server frische Summen liefert. Verhindert falsche Gesamtsumme.
  _hasServerTotals = false;
  // UPDATE TOTALS DYNAMICALLY - LÖST DEN BUG BEIM REDUZIEREN DER MENGE
  computeCartTotals();
}

let _desiredQty = Object.create(null);
let _qtyWriteScheduled = Object.create(null);

function linesForBundle(bundleId) {
  if (!bundleId) return [];
  return cart.filter((line) => line.bundleId === bundleId);
}

function applyBundleOptimistic(bundleId, targetQty) {
  const lines = linesForBundle(bundleId);
  lines.forEach((line) => {
    _desiredQty[line.key] = targetQty;
    applyOptimisticQty(line.key, targetQty);
  });
  return lines;
}

function writeBundleQuantities(lines, targetQty) {
  const updates = {};
  lines.forEach((line) => { updates[line.key] = targetQty; });
  return enqueueWrite(async () => {
    const result = await cartUpdate(updates);
    lines.forEach((line) => {
      delete _desiredQty[line.key];
      _qtyWriteScheduled[line.key] = false;
    });
    return await enforceBundleIntegrity(result);
  });
}

function removeBundleGroup(bundleId) {
  const lines = applyBundleOptimistic(bundleId, 0);
  if (!lines.length) return;
  _lastAdded = null;
  renderCart();
  writeBundleQuantities(lines, 0);
}

function bundleFreeLines(bundleId) {
  if (!bundleId) return [];
  return cart.filter((line) => line.bundleId === bundleId && line.bundleRole === "free");
}

function removeLinesTogether(lines) {
  const unique = [];
  const seen = new Set();
  (lines || []).forEach((line) => {
    if (!line || !line.key || seen.has(line.key)) return;
    seen.add(line.key);
    unique.push(line);
  });
  if (!unique.length) return;
  unique.forEach((line) => {
    _desiredQty[line.key] = 0;
    applyOptimisticQty(line.key, 0);
  });
  _lastAdded = null;
  renderCart();
  writeBundleQuantities(unique, 0);
}

function removeSingleLine(line) {
  if (!line || !line.key) return;
  applyOptimisticQty(line.key, 0);
  _lastAdded = null;
  renderCart();
  _desiredQty[line.key] = 0;
  if (!_qtyWriteScheduled[line.key]) {
    _qtyWriteScheduled[line.key] = true;
    flushQtyWrite(line.key);
  }
}

function removePaidBundleLineAndBonuses(line) {
  if (!line) return;
  const bonusLines = bundleFreeLines(line.bundleId);
  removeLinesTogether([line].concat(bonusLines));
}

function changeBundleGroupQty(bundleId, targetQty) {
  targetQty = Math.max(0, Number(targetQty) || 0);
  if (targetQty <= 0) { removeBundleGroup(bundleId); return; }
  const lines = applyBundleOptimistic(bundleId, targetQty);
  if (!lines.length) return;
  _lastAdded = null;
  renderCart();
  writeBundleQuantities(lines, targetQty);
}

function flushQtyWrite(key) {
  enqueueWrite(async () => {
    const q = key in _desiredQty ? _desiredQty[key] : null;
    _qtyWriteScheduled[key] = false;
    if (q === null) return null;
    try {
      const result = await cartChange(key, q);
      return result;
    } finally {
      if (_desiredQty[key] === q) delete _desiredQty[key];
    }
  });
}

function changeQty(key, delta) {
  if (String(key).indexOf("optimistic-") === 0) return; // Übergangszeile, gleich ersetzt
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  const target = Math.max(0, line.qty + delta);

  if (line.bundleId) {
    if (line.bundleRole === "free") {
      if (delta > 0) return;
      if (target <= 0) { removeSingleLine(line); return; }
    } else if (target <= 0) {
      removePaidBundleLineAndBonuses(line);
      return;
    }
  }

  if (target <= 0) { removeItem(key); return; }
  applyOptimisticQty(key, target);
  _lastAdded = null;
  renderCart();
  _desiredQty[key] = target;
  if (!_qtyWriteScheduled[key]) {
    _qtyWriteScheduled[key] = true;
    flushQtyWrite(key);
  }
}

function isFreeGuideLine(line) {
  return line && line.properties && (line.properties._mf_free_guide === "1" || line.properties._mf_free_guide === 1) && !line.bundleId;
}

// Entfernt die Einzelkauf-Gratis-Anleitung, wenn kein zahlendes Produkt mehr
// im Warenkorb ist (die Anleitung soll nie allein übrig bleiben).
function cleanupOrphanFreeGuide() {
  const guideLines = cart.filter(isFreeGuideLine);
  if (!guideLines.length) return;
  const hasPayingItem = cart.some((i) => !isFreeGuideLine(i) && i.bundleRole !== "free" && i.qty > 0);
  if (!hasPayingItem) {
    guideLines.forEach((g) => {
      applyOptimisticQty(g.key, 0);
      _desiredQty[g.key] = 0;
      if (!_qtyWriteScheduled[g.key]) {
        _qtyWriteScheduled[g.key] = true;
        flushQtyWrite(g.key);
      }
    });
  }
}

function removeItem(key) {
  if (String(key).indexOf("optimistic-") === 0) return; // Übergangszeile, gleich ersetzt
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  if (line.bundleId) {
    if (line.bundleRole === "free") { removeSingleLine(line); return; }
    removePaidBundleLineAndBonuses(line);
    return;
  }
  applyOptimisticQty(key, 0);
  _lastAdded = null;
  cleanupOrphanFreeGuide();
  renderCart();
  _desiredQty[key] = 0;
  if (!_qtyWriteScheduled[key]) {
    _qtyWriteScheduled[key] = true;
    flushQtyWrite(key);
  }
}

let _cartHideTimer = null;
function openCart() {
  const c = $("#cart"); if (!c) return;
  // Ein evtl. noch laufendes Schließen-Timeout abbrechen, sonst würde der
  // gerade wieder geöffnete Warenkorb fälschlich versteckt (hidden=true).
  if (_cartHideTimer) { clearTimeout(_cartHideTimer); _cartHideTimer = null; }
  const wasOpen = c.classList.contains("is-open");
  c.hidden = false;
  void c.offsetWidth;
  c.classList.add("is-open");
  document.body.style.overflow = "hidden";
  if (!wasOpen) document.dispatchEvent(new CustomEvent("couplezine:cart-opened"));
}

function closeCart() {
  const c = $("#cart"); if (!c) return;
  c.classList.remove("is-open");
  document.body.style.overflow = "";
  if (_cartHideTimer) clearTimeout(_cartHideTimer);
  _cartHideTimer = setTimeout(() => {
    // Nur verstecken, wenn der Warenkorb in der Zwischenzeit nicht wieder
    // geöffnet wurde.
    if (!c.classList.contains("is-open")) c.hidden = true;
    _cartHideTimer = null;
  }, 300);
}


function setupDrawer() {
  const burger = $("#burger");
  const drawer = $("#drawer");
  if (!burger || !drawer) return;
  let drawerHideTimer = null;
  const open = () => {
    if (drawerHideTimer) { clearTimeout(drawerHideTimer); drawerHideTimer = null; }
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    burger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  };
  const close = () => {
    drawer.classList.remove("is-open");
    burger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    if (drawerHideTimer) clearTimeout(drawerHideTimer);
    drawerHideTimer = setTimeout(() => {
      if (!drawer.classList.contains("is-open")) drawer.hidden = true;
      drawerHideTimer = null;
    }, 300);
  };
  burger.addEventListener("click", open);
  drawer.addEventListener("click", (e) => { if (e.target.closest("[data-drawer-close]")) close(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !drawer.hidden) close(); });
}

function setupStickyCta() {
  const cta = $("#sticky-cta");
  const hero = $(".hero");
  if (!cta || !hero || !("IntersectionObserver" in window)) return;
  const footer = document.querySelector(".footer");
  let heroPassed = false;   // Hero rausgescrollt?
  let footerSeen = false;   // Footer erreicht?

  const setPad = () => {
    document.documentElement.style.setProperty(
      "--sticky-h",
      cta.classList.contains("is-visible") ? cta.offsetHeight + "px" : "0px"
    );
  };
  const update = () => {
    // Sichtbar nur, wenn Hero vorbei UND Footer noch nicht erreicht (und mobil)
    const show = heroPassed && !footerSeen && window.innerWidth < 1040;
    cta.classList.toggle("is-visible", show);
    setPad();
  };

  const heroIo = new IntersectionObserver(([entry]) => {
    heroPassed = !entry.isIntersecting;
    update();
  }, { rootMargin: "-60px 0px 0px 0px" });
  heroIo.observe(hero);

  // Footer: sobald er ins Bild kommt, Sticky-Bar ausblenden
  if (footer) {
    const footIo = new IntersectionObserver(([entry]) => {
      footerSeen = entry.isIntersecting;
      update();
    }, { rootMargin: "0px 0px 0px 0px" });
    footIo.observe(footer);
  }
}

let _checkoutBusy = false;
function buildCheckoutUrl() {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
  let url = root.replace(/\/?$/, "/") + "checkout";
  // Nur einen vom KUNDEN eingegebenen Rabattcode an den Checkout übergeben.
  // Der Bundle-Rabatt selbst läuft als automatischer Rabatt in Shopify und
  // braucht keinen Code – so bleibt das Gutschein-Feld frei für Kundencodes.
  const activeCode = _appliedDiscount && _appliedDiscount.code ? _appliedDiscount.code : (_pendingDiscount || "");
  if (activeCode) {
    url += (url.indexOf("?") === -1 ? "?" : "&") + "discount=" + encodeURIComponent(activeCode);
  }
  return url;
}

async function goToCheckout(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }
  // Doppelklick / touchend+click-Doppelfeuern abfangen. Der Lock wird IMMER
  // wieder gelöst (finally) und zusätzlich per Timeout – so kann der Button
  // niemals dauerhaft "tot" bleiben (kein Refresh mehr nötig).
  if (_checkoutBusy) return;
  _checkoutBusy = true;

  // Sicherheitsnetz: egal was der Cart-Guard macht, nach spätestens 2,5 s wird
  // in jedem Fall zum Checkout navigiert. So hängt der Button nie an einer
  // langsamen/blockierten Netzwerkanfrage fest.
  let navigated = false;
  const navigate = () => {
    if (navigated) return;
    navigated = true;
    window.location.assign(buildCheckoutUrl());
  };
  const failSafe = setTimeout(navigate, 2500);

  try {
    // Cart-Guard läuft best-effort. Zusätzlich mit eigenem Timeout absichern,
    // damit ein hängendes fetch die Navigation nicht verzögert.
    await Promise.race([
      (async () => {
        const cleanCart = await enforceBundleIntegrity(await getCart());
        await applyServerCart(cleanCart);
      })(),
      new Promise((resolve) => setTimeout(resolve, 2000))
    ]);
  } catch (err) {
    console.error("couplezine checkout cart guard error:", err);
  } finally {
    clearTimeout(failSafe);
    _checkoutBusy = false;
    navigate();
  }
}

function setupCheckoutButton() {
  // Der Klick auf den Checkout-Button wird zentral über den delegierten
  // click-Handler in bindEvents() abgefangen ([data-checkout-button]).
  // Hier binden wir nur noch das Form-submit ab (z.B. Enter-Taste), damit der
  // Browser das Formular nicht ohne unsere Cart-Absicherung abschickt.
  // Bewusst KEIN zusätzlicher click/touchend-Listener am Button – das führte
  // sonst zu Doppel-Feuern (touchend + click) auf Mobilgeräten.
  const form = document.getElementById("cart-checkout-form");
  if (!form || form.dataset.checkoutReady === "1") return;
  form.dataset.checkoutReady = "1";
  form.addEventListener("submit", goToCheckout);
}

function bindEvents() {
  setupCheckoutButton();

  document.addEventListener("click", (e) => {
    const checkout = e.target.closest("[data-checkout-button]");
    if (checkout) { goToCheckout(e); return; }
    const add = e.target.closest(".add");
    if (add) { addItem(add.dataset.id, add.dataset.name); return; }
    if (e.target.closest("[data-cart-open]")) { openCart(); return; }
    if (e.target.closest("[data-cart-close]")) { closeCart(); return; }
    const inc = e.target.closest("[data-inc]");
    if (inc) { changeQty(inc.dataset.inc, +1); return; }
    const dec = e.target.closest("[data-dec]");
    if (dec) { changeQty(dec.dataset.dec, -1); return; }
    const rem = e.target.closest("[data-remove]");
    if (rem) { removeItem(rem.dataset.remove); return; }
  });

  const promoForm = $("#cart-promo");
  if (promoForm) {
    const input = $("#promo-input");
    const btn = $("#promo-btn");
    const msg = $("#promo-msg");
    const showMsg = (text, ok) => {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle("is-ok", !!ok);
      msg.classList.toggle("is-err", !ok);
      msg.hidden = false;
    };
    
    promoForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const code = (input.value || "").trim();
      promoForm.classList.remove("is-invalid", "is-active");
      
      if (!code) {
        if (_appliedDiscount || _pendingDiscount || _shopifyCodeDiscount > 0) {
          // SOFORT-FEEDBACK: Rabatt lokal entfernen, Summen neu rechnen,
          // Meldung zeigen — ohne auf den Server zu warten.
          _appliedDiscount = null;
          _pendingDiscount = null;
          _shopifyCodeDiscount = 0;
          _hasServerTotals = false;
          computeCartTotals();
          renderCart();
          btn.textContent = "einlösen";
          if (msg) { showMsg("rabattcode entfernt.", true); }
          const saveEl = $("#cart-save"); if (saveEl) popEl(saveEl);
          const totEl = $("#cart-total"); if (totEl) popEl(totEl);

          // HINTERGRUND: verlässlich bei Shopify entfernen (mit Verifikation,
          // damit der Rabatt nicht "zurückkommt") und danach die exakten
          // Server-Summen still nachziehen.
          (async () => {
            try {
              const cleared = await clearDiscountCode();
              const fresh = cleared || (await getCart());
              mapShopifyCartItems(fresh);
            } catch (e) {}
            _shopifyCodeDiscount = 0;
            computeCartTotals();
            renderCart();
          })();
        } else {
          btn.classList.remove("nudge"); void btn.offsetWidth; btn.classList.add("nudge");
        }
        return;
      }
      btn.disabled = true;
      const original = btn.textContent;
      btn.textContent = "…";
      
      try {
        if (cartQty() === 0) {
          try {
            await fetch("/discount/" + encodeURIComponent(code), { method: "GET", redirect: "manual" });
          } catch (e) {}
          _pendingDiscount = code;
          btn.textContent = original;
          promoForm.classList.remove("is-invalid", "is-active");
          showMsg("code vorgemerkt – füge produkte hinzu, dann wird er angewendet.", true);
          if (input && !input.value.trim()) input.value = code.toUpperCase();
          return;
        }
        const res = await applyDiscountCode(code);
        if (res.ok) {
          promoForm.classList.add("is-active");
          btn.textContent = "aktiv";
          showMsg("code '" + code.toUpperCase() + "' angewendet.", true);
          renderCart();
          const saveEl = $("#cart-save"); if (saveEl) popEl(saveEl);
          const totEl = $("#cart-total"); if (totEl) popEl(totEl);
        } else {
          btn.textContent = original;
          promoForm.classList.remove("is-invalid"); void promoForm.offsetWidth;
          promoForm.classList.add("is-invalid");
          renderCart();
          showMsg(res.reason === "not_applicable"
            ? "code gilt für diesen warenkorb nicht."
            : "dieser code ist leider ungültig.", false);
        }
      } catch (err) {
        btn.textContent = original;
        promoForm.classList.add("is-invalid");
        showMsg("code konnte nicht geprüft werden.", false);
      } finally {
        btn.disabled = false;
      }
    });
    
    if (input) {
      let _editRemoveTimer = null;
      input.addEventListener("input", () => {
        promoForm.classList.remove("is-invalid");
        const active = _appliedDiscount ? _appliedDiscount.code.toUpperCase() : null;
        const typed = input.value.trim().toUpperCase();

        // Sobald ein aktiver Rabatt vorliegt und der eingegebene Code davon
        // abweicht (z.B. ein Buchstabe entfernt), den Rabatt wirklich lösen.
        const hasActive = active || _shopifyCodeDiscount > 0;
        if (hasActive && typed !== active) {
          // UI sofort auf "nicht aktiv" setzen (direktes Feedback).
          promoForm.classList.remove("is-active");
          if (btn) btn.textContent = "einlösen";
          if (msg) {
            showMsg(typed === ""
              ? "code entfernt."
              : "code geändert – nicht mehr aktiv.", true);
          }

          // SOFORT-FEEDBACK: Summen ohne Rabatt anzeigen, nicht erst nach dem
          // Server-Roundtrip. Den entfernten Code merken, um ein erneutes
          // Eintippen desselben Codes erkennen zu können.
          const removedCode = _appliedDiscount ? String(_appliedDiscount.code).toUpperCase() : null;
          _appliedDiscount = null;
          _pendingDiscount = null;
          _shopifyCodeDiscount = 0;
          _hasServerTotals = false;
          computeCartTotals();
          renderCart();
          const saveEl0 = $("#cart-save"); if (saveEl0) popEl(saveEl0);
          const totEl0 = $("#cart-total"); if (totEl0) popEl(totEl0);

          // HINTERGRUND: Rabatt tatsächlich bei Shopify entfernen (leicht
          // verzögert, damit nicht bei jedem Tastendruck ein Call losgeht).
          clearTimeout(_editRemoveTimer);
          _editRemoveTimer = setTimeout(async () => {
            // Falls der Nutzer inzwischen wieder den exakten aktiven Code
            // getippt hat: nichts entfernen, Zustand vom Server zurückholen.
            const nowTyped = input.value.trim().toUpperCase();
            if (removedCode && nowTyped === removedCode) {
              try { await applyServerCart(await getCart()); } catch (e) {}
              return;
            }

            try {
              const cleared = await clearDiscountCode();
              const fresh = cleared || (await getCart());
              mapShopifyCartItems(fresh);
            } catch (e) {}
            _shopifyCodeDiscount = 0;
            computeCartTotals();
            renderCart();
          }, 350);
        }
      });
    }
    
    let nudgeTimer;
    document.addEventListener("couplezine:cart-opened", () => {
      clearTimeout(nudgeTimer);
      nudgeTimer = setTimeout(() => {
        if (!promoForm.classList.contains("is-active") && btn && (!input || !input.value.trim())) {
          btn.classList.remove("nudge"); void btn.offsetWidth; btn.classList.add("nudge");
        }
      }, 2600);
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeCart();
  });

  const form = $("#newsletter-form");
  if (form) {
    form.addEventListener("submit", (e) => {
      // Wir übernehmen den Versand per fetch, damit die Seite nicht neu lädt –
      // aber die E-Mail MUSS trotzdem bei Shopify ankommen. Vorher wurde das
      // Formular nur zurückgesetzt und die Anmeldung ging verloren.
      e.preventDefault();

      const emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
      const email = emailInput ? (emailInput.value || "").trim() : "";
      if (!email) { if (emailInput) emailInput.focus(); return; }

      const submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      const body = new FormData(form);
      // Shopify erwartet form_type=customer für Newsletter-Anmeldungen.
      if (!body.get("form_type")) body.set("form_type", "customer");
      if (!body.get("utf8")) body.set("utf8", "✓");

      fetch(form.getAttribute("action") || "/contact", {
        method: "POST",
        headers: { "Accept": "application/json, text/html" },
        body: body
      })
        .then(() => {
          // Shopify liefert für den Customer-Kontaktendpunkt nicht immer sauberes
          // JSON zurück; wir behandeln einen erfolgten POST als Erfolg, solange
          // kein Netzwerkfehler auftrat.
          form.reset();
          showToast("willkommen in der couplezine family ♥");
        })
        .catch((err) => {
          console.error("couplezine newsletter submit error:", err);
          showToast("anmeldung fehlgeschlagen – bitte erneut versuchen");
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }
}

function initProductPage() {
  const root = document.querySelector(".pdp") || document.querySelector(".pdp__top");
  if (!root) return;
  let qty = 1;
  const posterOffer = root.querySelector("[data-mfy-poster-offer]");

  function setPosterOfferQuantity(nextQuantity) {
    if (!posterOffer) return;
    const parsed = Number(nextQuantity);
    qty = [1, 2, 3].includes(parsed) ? parsed : 1;
    const choices = Array.from(posterOffer.querySelectorAll("[data-mfy-offer-qty]"));
    const active = choices.find((choice) => Number(choice.dataset.mfyOfferQty) === qty) || choices[0];

    choices.forEach((choice) => {
      const selected = choice === active;
      choice.classList.toggle("is-active", selected);
      choice.setAttribute("aria-checked", selected ? "true" : "false");
    });

    const quantityInput = document.querySelector("#product-upload-form input[name='quantity']");
    if (quantityInput) quantityInput.value = String(qty);

    const propertyInput = document.getElementById("mfy-poster-offer-property");
    if (propertyInput) propertyInput.value = qty + " Poster";

    const saving = posterOffer.querySelector("[data-mfy-offer-saving-output]");
    if (saving && active) saving.textContent = active.dataset.mfyOfferSaving || "";

    const buyButton = document.getElementById("buy-add");
    const buyText = buyButton && buyButton.querySelector(".buy__add-main");
    if (buyText) buyText.textContent = qty === 1 ? "In den Warenkorb legen" : qty + " Poster in den Warenkorb";

    const stickyButton = document.getElementById("sticky-add");
    if (stickyButton) stickyButton.textContent = qty === 1 ? "In den Warenkorb" : qty + " Poster hinzufügen";

    const stickyPrice = document.getElementById("sticky-price");
    if (stickyPrice && active && active.dataset.mfyOfferTotal) stickyPrice.textContent = active.dataset.mfyOfferTotal;
  }

  function currentSellingPlan() {
    const pick = document.querySelector("#purchase-pick .pseg__opt.is-active");
    const val = pick ? (pick.dataset.sellingPlan || "") : "";
    return val || null;
  }

  function setPurchaseMode(activeCard) {
    const pick = document.getElementById("purchase-pick");
    if (!pick || !activeCard) return;
    const opts = Array.prototype.slice.call(pick.querySelectorAll(".pseg__opt"));
    opts.forEach((c) => {
      const on = c === activeCard;
      c.classList.toggle("is-active", on);
      c.setAttribute("aria-pressed", on ? "true" : "false");
    });
    const isRight = opts.indexOf(activeCard) === 1;
    pick.classList.toggle("is-right", isRight);
    
    const plan = activeCard.dataset.sellingPlan || "";
    const input = document.getElementById("selling-plan-input");
    if (input) input.value = plan;
    const buyAdd = document.getElementById("buy-add");
    if (buyAdd) {
      if (plan) buyAdd.dataset.sellingPlan = plan;
      else delete buyAdd.dataset.sellingPlan;
    }
    // Sticky-Leiste an die gewählte Kaufart anpassen (Abo-/Einmalpreis)
    if (typeof window.__syncStickyPrice === "function") window.__syncStickyPrice();
  }

  root.addEventListener("click", (e) => {
    const posterOfferChoice = e.target.closest("[data-mfy-offer-qty]");
    if (posterOfferChoice && posterOffer && posterOffer.contains(posterOfferChoice)) {
      setPosterOfferQuantity(posterOfferChoice.dataset.mfyOfferQty);
      return;
    }

    const pickCard = e.target.closest(".pseg__opt");
    if (pickCard) { setPurchaseMode(pickCard); return; }
    
    const th = e.target.closest("[data-thumb]");
    if (th) {
      const track = $("#gallery-track");
      const idx = parseInt(th.dataset.index, 10);
      if (track && !isNaN(idx) && track.children[idx]) {
        track.children[idx].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
      document.querySelectorAll("[data-thumb]").forEach((t) => t.classList.toggle("is-active", t === th));
      return;
    }

    const buyAdd = e.target.closest("#buy-add");
    if (buyAdd) {
      if (root.classList.contains("mfy-poster-pdp")) {
        addItem(buyAdd.dataset.variant, buyAdd.dataset.name, qty, currentSellingPlan(), false, collectLineItemProperties());
        addSelectedMfyPosterUpsells();
      } else {
        addItemWithGuide(buyAdd.dataset.variant, buyAdd.dataset.name, 1, currentSellingPlan(), buyAdd.dataset.druckservice === "1");
      }
      return;
    }
  });

  const productForm = document.getElementById("product-form");
  if (productForm) {
    productForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const buyAdd = $("#buy-add");
      if (buyAdd && !buyAdd.disabled) buyAdd.click();
    });
  }

  const stickyAdd = $("#sticky-add");
  if (stickyAdd) {
    stickyAdd.addEventListener("click", () => {
      const buyAdd = $("#buy-add");
      const variantId = buyAdd && buyAdd.dataset.variant;
      if (root.classList.contains("mfy-poster-pdp")) {
        addItem(variantId, buyAdd && buyAdd.dataset.name, qty, currentSellingPlan(), false, collectLineItemProperties());
        addSelectedMfyPosterUpsells();
      } else {
        addItemWithGuide(variantId, buyAdd && buyAdd.dataset.name, 1, currentSellingPlan(), buyAdd && buyAdd.dataset.druckservice === "1");
      }
    });
  }

  if (posterOffer) setPosterOfferQuantity(posterOffer.dataset.defaultQuantity || 2);

  const fl = $("#faq-list");
  if (fl) {
    fl.addEventListener("click", (e) => {
      const q = e.target.closest(".faq__q"); if (!q) return;
      const item = q.closest(".faq__item");
      const a = item.querySelector(".faq__a");
      const open = item.classList.toggle("is-open");
      a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
    });
    // Bei Größenänderung des Fensters die Höhe offener Antworten neu berechnen,
    // damit längerer Text (der jetzt mehr Zeilen umbricht) nicht abgeschnitten
    // wird.
    let faqResizeRaf = 0;
    window.addEventListener("resize", () => {
      if (faqResizeRaf) return;
      faqResizeRaf = requestAnimationFrame(() => {
        faqResizeRaf = 0;
        fl.querySelectorAll(".faq__item.is-open .faq__a").forEach((a) => {
          a.style.maxHeight = a.scrollHeight + "px";
        });
      });
    });
  }

  const sticky = $("#pdp-sticky"), anchor = $(".buy__row");
  if (sticky && anchor && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(([en]) => {
      sticky.classList.toggle("is-visible", !en.isIntersecting && window.innerWidth < 1040);
      document.documentElement.style.setProperty("--sticky-h", sticky.classList.contains("is-visible") ? sticky.offsetHeight + "px" : "0px");
    }, { rootMargin: "0px 0px -40px 0px" });
    io.observe(anchor);
  }

  const galTrack = $("#gallery-track");
  if (galTrack) {
    const setActive = (idx) => {
      document.querySelectorAll(".gthumb").forEach((t) =>
        t.classList.toggle("is-active", parseInt(t.dataset.index, 10) === idx)
      );
    };
    let galRaf = 0;
    galTrack.addEventListener("scroll", () => {
      if (galRaf) return;
      galRaf = requestAnimationFrame(() => {
        galRaf = 0;
        const idx = Math.round(galTrack.scrollLeft / galTrack.clientWidth);
        setActive(idx);
      });
    }, { passive: true });
    
    let down = false, startX = 0, startScroll = 0, moved = false;
    const main = galTrack.closest(".gallery__main");
    galTrack.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "mouse") {
        down = true; moved = false;
        startX = e.clientX; startScroll = galTrack.scrollLeft;
        if (main) main.classList.add("is-grabbing");
      }
    });
    galTrack.addEventListener("pointermove", (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      galTrack.scrollLeft = startScroll - dx;
    });
    const endDrag = () => {
      if (!down) return;
      down = false;
      if (main) main.classList.remove("is-grabbing");
      const idx = Math.round(galTrack.scrollLeft / galTrack.clientWidth);
      if (galTrack.children[idx]) {
        galTrack.children[idx].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    };
    galTrack.addEventListener("pointerup", endDrag);
    galTrack.addEventListener("pointerleave", endDrag);
    galTrack.addEventListener("click", (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  // ---- Wirkung-Section: Zahlen zählen hoch, sobald sie sichtbar werden ----
  const impactNums = document.querySelectorAll("#impact-grid .impact__num");
  if (impactNums.length && "IntersectionObserver" in window) {
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const runCount = (el) => {
      const valEl = el.querySelector(".impact__val");
      if (!valEl || el.dataset.counted === "1") return;
      el.dataset.counted = "1";
      const to = parseFloat(el.dataset.countTo);
      const decimals = parseInt(el.dataset.countDecimals, 10) || 0;
      if (isNaN(to)) { valEl.textContent = el.dataset.countTo || ""; return; }
      const dur = 1400; const start = performance.now();
      const tick = (now) => {
        const p = Math.min(1, (now - start) / dur);
        const cur = to * easeOut(p);
        valEl.textContent = cur.toFixed(decimals).replace(".", ",");
        if (p < 1) requestAnimationFrame(tick);
        else valEl.textContent = to.toFixed(decimals).replace(".", ",");
      };
      requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { runCount(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    impactNums.forEach((n) => io.observe(n));
  }

  // ---- Ablauf-Section (3 Sekunden): Schritte erscheinen nacheinander ----
  const howSteps = document.querySelectorAll("#how-steps .how__step");
  if (howSteps.length && "IntersectionObserver" in window) {
    const howIo = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.3 });
    howSteps.forEach((s) => howIo.observe(s));
  } else {
    // Fallback ohne Observer: direkt sichtbar
    howSteps.forEach((s) => s.classList.add("is-in"));
  }

  // ---- Clean-Beauty-Section: Karten beim Scrollen einblenden ----
  const cleanCards = document.querySelectorAll("#clean-grid .clean__card");
  if (cleanCards.length && "IntersectionObserver" in window) {
    const cleanIo = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.25 });
    cleanCards.forEach((c) => cleanIo.observe(c));
  } else {
    cleanCards.forEach((c) => c.classList.add("is-in"));
  }

}

function initRoutine() {
  const routineSteps = document.querySelectorAll("#routine-steps .routine__step");
  const routineSlides = document.querySelectorAll(".routine__stage .routine__slide");
  if (!routineSteps.length || !routineSlides.length) return;
  const activateRoutine = (idx) => {
    routineSteps.forEach((s) => {
      const on = s.dataset.routineIndex === String(idx);
      s.classList.toggle("is-active", on);
      s.setAttribute("aria-selected", on ? "true" : "false");
    });
    routineSlides.forEach((sl) => {
      sl.classList.toggle("is-active", sl.dataset.routineSlide === String(idx));
    });
  };
  routineSteps.forEach((s) => {
    s.addEventListener("click", () => activateRoutine(s.dataset.routineIndex));
    s.addEventListener("mouseenter", () => activateRoutine(s.dataset.routineIndex));
  });
}

function __couplezineInit() {
  revealBenefits();
  syncCartFromShopify();
  startCountdown();
  setupDrawer();
  setupStickyCta();
  initProductPage();
  initRoutine();
  bindEvents();
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", __couplezineInit);
else __couplezineInit();
